/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminProfileDetailDto,
  ErrorResponse,
  InviteAdminUserRequestDto,
} from '../models/index';
import {
    AdminProfileDetailDtoFromJSON,
    AdminProfileDetailDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InviteAdminUserRequestDtoFromJSON,
    InviteAdminUserRequestDtoToJSON,
} from '../models/index';

export interface GetAdminUserDetailRequest {
    userId: string;
}

export interface InviteAdminUserRequest {
    inviteAdminUserRequestDto: InviteAdminUserRequestDto;
}

/**
 * 
 */
export class AdminUsersApi extends runtime.BaseAPI {

    /**
     * Get detailed information about an admin user
     * Get admin user detail
     */
    async getAdminUserDetailRaw(requestParameters: GetAdminUserDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProfileDetailDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getAdminUserDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin-users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProfileDetailDtoFromJSON(jsonValue));
    }

    /**
     * Get detailed information about an admin user
     * Get admin user detail
     */
    async getAdminUserDetail(requestParameters: GetAdminUserDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProfileDetailDto> {
        const response = await this.getAdminUserDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invite a new admin user to the Cellera admin portal
     * Invite admin user
     */
    async inviteAdminUserRaw(requestParameters: InviteAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['inviteAdminUserRequestDto'] == null) {
            throw new runtime.RequiredError(
                'inviteAdminUserRequestDto',
                'Required parameter "inviteAdminUserRequestDto" was null or undefined when calling inviteAdminUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin-users/invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteAdminUserRequestDtoToJSON(requestParameters['inviteAdminUserRequestDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invite a new admin user to the Cellera admin portal
     * Invite admin user
     */
    async inviteAdminUser(requestParameters: InviteAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.inviteAdminUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
